const defaultConfig = {
  cookieName: 'cctr_cookie_settings',
  modalHasBg: true,
  modalTitle: 'Our use of cookies',
  modalIntro: 'We use cookies to make our site work. We’d also like to set optional cookies to analyse visits and provide additional functionality. You can manage the cookies and we will remember your preferences <a href="/privacy">Privacy Page</a>',
  options: [
    {
      name: 'necessary',
      title: 'Necessary cookies',
      description: 'Necessary cookies enable core functionality such as security, network management, accessibility and third-party embedded content.  You may disable these by changing your browser settings, but this may affect how the website functions.',
      label: 'Enable',
      defaultChecked: true,
      disabled: true,
    },
    // {
    //   name: 'embed',
    //   title: 'Embedded content',
    //   description: 'We embed videos from YouTube using YouTube’s privacy-enhanced mode. This mode may set cookies on your computer once you click on the YouTube video player, but YouTube will not store personally-identifiable cookie information for playbacks of embedded videos using the privacy-enhanced mode.',
    //   label: 'Enable',
    //   defaultChecked: false,
    // },
    {
      name: 'analytics',
      title: 'Analytics cookies',
      description: 'We’d like to set Google Analytics cookies to collect information on how the site is used. The cookies collect information in a way that does not directly identify anyone. For more information on how these cookies work, please see our <a href="/privacy">Privacy Page</a>.',
      label: 'Enable',
      defaultChecked: false,
    },
  ],
}

export default defaultConfig
